<template functional>
  <div
    class="vm-message-wrap"
    :class="{
      'vm-start': props.data.isStart,
      'vm-end': props.data.isEnd,
      'vm-middle': !props.data.isStart && !props.data.isEnd,
      'vm-im': props.data.isMe
    }"
  >
    <div v-if="props.data.isNextDay" class="vm-date">
      {{ props.data.dayTitle }}
    </div>
    <div class="vm-message">
      <div v-if="props.data.isStart" class="vm-title">
        {{ props.data.user }}
      </div>
      <div v-if="typeof props.data.text !== 'undefined'" class="vm-text">
        {{ props.data.text }}
      </div>
      <div v-else-if="props.data.file.type === 'file'" class="vm-file-block">
        <div class="vm-download-icon">
          <i class="material-icons">insert_drive_file</i>
        </div>
        <div class="vm-download-info">
          <div class="vm-download-name">{{ props.data.file.name }}</div>
          <div v-if="props.data.file.data" classs="vm-download-link">
            <button @click="listeners.click" type="button" class="vm-link-button">
              Скачать
            </button>
          </div>
        </div>
      </div>
      <div class="vm-message-image" v-else>
        <img @click="listeners.clickImage" :src="props.data.file.data" alt="image" />
      </div>
      <div class="vm-time">
        <i
          v-if="props.data.status === 'wait'"
          class="material-icons wait"
        >
          access_time
        </i>
        <i v-else class="material-icons">done_all</i>
        {{ props.data.time }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      dayTitle: String,
      id: Number,
      isEnd: Boolean,
      isNextDay: Boolean,
      isStart: Boolean,
      text: String,
      time: String,
      timestamp: String,
      user: String,
      userId: Number
    }
  }
};
</script>

<style scoped>
.vm-text {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}
.vm-message-image {
  display: flex;
}
.vm-message-image img {
  max-width: 100%;
  max-height: 300px;
}
.vm-message-wrap {
  display: flex;
  flex-direction: column;
}
.vm-date {
  font-weight: 600;
  align-self: center;
  margin-bottom: 12px;
}
.vm-message {
  background-color: rgb(225, 201, 245);
  padding: 6px;
  border-radius: 6px 12px 12px 6px;
  align-self: flex-start;
}
.vm-im {
  justify-content: flex-end;
}
.vm-im .vm-message {
  background-color: rgb(205, 216, 242);
  border-radius: 12px 6px 6px 12px;
  align-self: flex-end;
}
.vm-im.vm-start .vm-message {
  border-radius: 12px 12px 6px 12px;
}
.vm-im.vm-end.vm-start .vm-message {
  border-radius: 12px 12px 0 12px;
}
.vm-im.vm-end .vm-message {
  border-radius: 12px 6px 0 12px;
}
.vm-start .vm-message {
  margin-bottom: 6px;
  border-radius: 12px 12px 12px 6px;
}
.vm-middle .vm-message {
  margin-bottom: 6px;
}
.vm-end .vm-message {
  margin-bottom: 12px;
  border-radius: 6px 12px 12px 0px;
}
.vm-start.vm-end .vm-message {
  border-radius: 12px 12px 12px 0;
}
.vm-message .vm-title {
  font-weight: 500;
  font-size: 16px;
  line-height: 1;
  margin-bottom: 6px;
  color: rgb(73, 30, 129)
}
.vm-time {
  font-size: 13px;
  color: rgba(0, 0, 0, 0.6);
  font-weight: 300;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.vm-time i {
  font-size: 16px;
  margin-right: 4px;
  color: rgba(86, 72, 202, 0.7);
}
.vm-time i.wait {
  font-size: 16px;
  margin-right: 4px;
  color: rgba(0, 0, 0, 0.6);
}
.vm-attach-file-button {
  outline: 0;
}
.vm-file-block {
  display: flex;
  padding: 6px 0;
  align-items: center;
}
.vm-download-icon {
  flex: 0 0 50px;
  width: 50px;
  height: 50px;
  background-color: rgba(255, 255, 255, 0.4);
  border-radius: 50%;
  margin-right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.vm-download-icon i {
  color: rgb(99, 66, 209, 0.7);
}
.vm-download-name {
  font-weight: 600;
}
.vm-link-button {
  display: inline;
  cursor: pointer;
  background-color: transparent;
  border: 0;
  padding: 0;
  margin: 0;
  outline: 0;
}
.vm-link-button:hover {
  color: rgb(87, 73, 207);
}
@media (max-width: 1280px) {
  .vm-message-image img {
    max-height: 180px;
  }
  .vm-time {
    font-size: 12px;
  }
  .vm-message .vm-title {
    font-size: 14px;
  }
  .vm-text {
    font-size: 12px;
  }
  .vm-date {
    font-size: 14px;
  }
  .vm-download-icon {
    flex: 0 0 34px;
    width: 34px;
    height: 34px;
  }
  .vm-download-icon i {
    font-size: 18px;
  }
  .vm-download-name {
    font-size: 14px;
  }
  .vm-link-button {
    font-size: 12px;
    display: block;
  }
  .vm-time {
    font-size: 9px;
  }
  .vm-time i {
    font-size: 12px;
  }
  .vm-time i.wait {
    font-size: 12px;
  }
}
</style>